export default __webpack_public_path__ + "static/media/data.cc65b9a3.svg";